import angular from 'angular';
import common from './core.module';
const moduleName = 'atc-club';
import ClubCalendarController from './controllers/club/calendar.controller';
import ClubCourtsController from './controllers/club/courts.controller';
import ClubCourtsPaymentController from './controllers/club/courts.payment.controller';
import ClubCourtsPolicyController from './controllers/club/courts.policy.controller';
import ClubCourtsPricesController from './controllers/club/courts.prices.controller';
import ClubProfileController from './controllers/club/profile.controller';
import ClubProfileOpenHoursController from './controllers/club/profile.openhours.controller';
import ClubUsersController from './controllers/club/users.controller';
import CropperController from './components/cropper/cropper.controller';

angular.module(moduleName, [common])
    .controller('ClubCalendarController', ClubCalendarController)
    .controller('ClubCourtsController', ClubCourtsController)
    .controller('ClubCourtsPaymentController', ClubCourtsPaymentController)
    .controller('ClubCourtsPolicyController', ClubCourtsPolicyController)
    .controller('ClubCourtsPricesController', ClubCourtsPricesController)
    .controller('ClubProfileController', ClubProfileController)
    .controller('ClubProfileOpenHoursController', ClubProfileOpenHoursController)
    .controller('ClubUsersController', ClubUsersController)
    .controller('CropperController', CropperController)
;


export default moduleName;